import {
  ACTION_LOAD_CHART_DATA__REQUEST,
  ACTION_LOAD_CHART_DATA__SUCCESS,
  ACTION_LOAD_CHART_DATA__FAIL,
} from '../actionTypes';


const error = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_CHART_DATA__REQUEST:
    case ACTION_LOAD_CHART_DATA__SUCCESS:
      return null;

    case ACTION_LOAD_CHART_DATA__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};

export default error;
